<div class="col-lg-6 col-md-8 col-sm-10 col-lg-offset-3 col-md-offset-2 col-sm-offset-1 push-up-50 push-down-50">
  <div class="panel-auth">
    <div class="auth-header">
      <div class="page-title">Forgot Password</div>
      <div class="page-sub-title">
        Retrieve your forgotten password
      </div>
    </div>

    <div class="clear"></div>

    <h5 *ngIf="!actionComplete" class="panel-sub-title-alt push-down-30">Please enter your Email Address so we <br>can send you a password reset link</h5>

    <form novalidate [formGroup]="myForm" (ngSubmit)="onSubmit()">
      <div class="col-xs-10 col-xs-offset-1" *ngIf="actionComplete">
        <h5 class="panel-title push-down-30">Password Reset Link Sent</h5>

        <div class="push-up-30">
          <div class="profile-sec-wrap">
            <div class="panel-sub-title">{{message}}</div>
          </div>
        </div>

        <div class="clear"></div>

        <div class="col-sm-8 col-sm-offset-2 push-up-30">
          <a class="btn-main-proceed-alt" href="/">Try Again</a>
        </div>
        <div class="clear"></div>
      </div>

      <div class="clear"></div>

      <div class="col-xs-10 col-xs-offset-1 push-down-10" *ngIf="!actionComplete">
        <div class="form-elem">
          <div class="form-elem-name">Email Address</div>
          <div class="form-elem-field">
            <input type="text" [formControl]="myForm.controls['email']" [(ngModel)]="email" />
            <div *ngIf="!myForm.controls['email'].valid && myForm.controls['email'].touched" class="mb-error-fail-wrap"><div class="mb-error-fail">Email Required</div></div>
          </div>
        </div>
      </div>

      <div class="clear"></div>

      <div class="col-sm-8 col-sm-offset-2 push-down-20 push-up-30" *ngIf="!actionComplete">
        <input class="btn-main-proceed-alt" type="submit" value="Next" />
      </div>

      <div class="clear"></div>
    </form>
  </div>
</div>
